import styled from 'styled-components';

export const ZillowNavbarSubSectionLinksList = styled.ul`
    padding: 0px;
    list-style-type: none;
    list-style-position: outside;
`;
